/** @jsxImportSource @emotion/react */
import { hooks as commonHooks } from '@sitebuilder/common';

const LEFT_COLUMN_ID = 'leftColumn';
const RIGHT_COLUMN_ID = 'rightColumn';

interface PropsShape {
    data: any;
    widgetInstanceId: string;
    isRender?: {
        renderLeftColumn: boolean;
        renderRightCoulmn: boolean;
    };
    leftColumnOptions?: any;
    rightColumnOptions?: any;
}

const TwoColumnLayout = (props: PropsShape) => {
    const { isRender, data, widgetInstanceId, leftColumnOptions, rightColumnOptions } = props;
    const { Placeholder } = commonHooks.useAppContext();

    let shouldRenderLeftColumn = true;
    let shouldRenderRightColumn = true;

    if (isRender) {
        shouldRenderLeftColumn = isRender.renderLeftColumn;
        shouldRenderRightColumn = isRender.renderRightCoulmn;
    }

    return (
        <>
            {shouldRenderLeftColumn && (
                <div style={leftColumnOptions || undefined} className="left-column">
                    <Placeholder
                        data={data}
                        contentPlaceHolderId={LEFT_COLUMN_ID}
                        parentWidgetInstanceId={widgetInstanceId}
                    />
                </div>
            )}
            {shouldRenderRightColumn && (
                <div style={rightColumnOptions || undefined} className="right-column">
                    <Placeholder
                        data={data}
                        contentPlaceHolderId={RIGHT_COLUMN_ID}
                        parentWidgetInstanceId={widgetInstanceId}
                    />
                </div>
            )}
        </>
    );
};

export default TwoColumnLayout;
